import { useEffect, useState } from "react";
import { Copy, Volume2, VolumeX, RotateCcw, Globe } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { copyText, playUhOh } from "../lib/api";
import { useI18n } from "../lib/i18n";

export const UinSuccess = ({ result, onReset }) => {
  const { t } = useI18n();
  const [sound, setSound] = useState(true);
  const [showPw, setShowPw] = useState(false);

  useEffect(() => { playUhOh(); }, []);

  const copy = async () => {
    await copyText(String(result.uin));
    if (sound) playUhOh();
    toast.success(t("uinCopied"), { description: String(result.uin) });
  };

  return (
    <div data-testid="register-success" className="rise text-center">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#6E7681]">{t("yourUin")}</p>
      <p data-testid="register-success-uin" className="mt-4 font-mono text-4xl sm:text-5xl font-extrabold tracking-widest text-[#3FB950] break-all">
        {result.uin}
      </p>
      {result.nickname && <p className="mt-2 text-[#8B949E]">{t("welcome")} {result.nickname}</p>}
      <div className="mt-8 grid grid-cols-3 gap-3 text-left font-mono text-xs sm:text-sm">
        {[["server", t("sServer"), result.server_host], ["port", t("sPort"), result.server_port], ["password", t("sPassword"), showPw ? result.password : "••••••"]].map(([id, k, v]) => (
          <div key={id} className="rounded-lg bg-[#0D1117] border border-[#30363D] p-3">
            <p className="text-[#6E7681]">{k}</p>
            <p data-testid={`register-success-${id}`} className="mt-1 text-[#38BDF8] truncate cursor-pointer"
              onClick={() => id === "password" && setShowPw(!showPw)}>{v}</p>
          </div>
        ))}
      </div>
      <p className="mt-4 text-xs text-[#D29922]">{t("writeDown")}</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Button onClick={copy} data-testid="copy-uin-btn" className="rounded-full bg-[#3FB950] text-[#0D1117] hover:bg-[#2EA043] font-semibold">
          <Copy className="mr-2 h-4 w-4" /> {t("copyUin")}
        </Button>
        <Button asChild variant="outline" data-testid="success-webclient-btn"
          className="rounded-full border-[#38BDF8]/50 bg-transparent text-[#38BDF8] hover:bg-[#21262D]">
          <a href="https://kicq.su" target="_blank" rel="noopener noreferrer">
            <Globe className="mr-2 h-4 w-4" /> {t("loginWeb")}
          </a>
        </Button>
        <Button variant="outline" onClick={() => setSound(!sound)} data-testid="toggle-sound-btn"
          className="rounded-full border-[#30363D] bg-transparent hover:bg-[#21262D]">
          {sound ? <Volume2 className="mr-2 h-4 w-4" /> : <VolumeX className="mr-2 h-4 w-4" />} {t(sound ? "soundOn" : "soundOff")}
        </Button>
        <Button variant="ghost" onClick={onReset} data-testid="register-another-btn" className="rounded-full hover:bg-[#21262D]">
          <RotateCcw className="mr-2 h-4 w-4" /> {t("another")}
        </Button>
      </div>
    </div>
  );
};
